import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/css/common.css';
import styles from '../assets/css/member-registration.module.css';
import CustomButtons from '../components/CustomButtons';
import customFetch from '../utils/fetch';
import { API_ENDPOINTS } from '../constants/api-endpoint';

function ChangePassword() {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('すべての項目を入力してください。');
      return;
    }
    if (newPassword.length < 8) {
      setError('新しいパスワードは8文字以上必要です。');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('新しいパスワードと確認用パスワードが一致しません。');
      return;
    }

    setLoading(true);
    try {
      await customFetch(API_ENDPOINTS.PASSWORD_CHANGE, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ currentPassword, newPassword })
      });
      setSuccess('パスワードを変更しました。');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err?.data?.error || err.message || 'パスワード変更に失敗しました。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.mainContents}>
      <div className={styles.container}>
        <div className={styles["registration-card"]}>
          <h1 className={`${styles["text-primary"]} text-center mb-4`}>パスワード変更</h1>

          {error && <div className="alert alert-danger">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">現在のパスワード</label>
              <input
                type="password"
                className="form-control"
                value={currentPassword}
                onChange={e => setCurrentPassword(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">新しいパスワード</label>
              <input
                type="password"
                className="form-control"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                placeholder="8文字以上"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">新しいパスワード（確認）</label>
              <input
                type="password"
                className="form-control"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
              />
            </div>

            <CustomButtons
              leftLabel="戻る"
              onLeftClick={() => navigate('/')}
              rightLabel="変更する"
              rightLoadingLabel="変更中..."
              rightLoading={loading}
              rightDisabled={loading}
              rightType="submit"
            />
          </form>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
